import { computed as t } from "vue";
function o(r) {
  return t(() => {
    if (typeof r == "string")
      return isNaN(r) ? r : `${r}px`;
    if (typeof r == "number")
      return `${r}px`;
  });
}
export {
  o as scalarCssValue
};
